import { render, staticRenderFns } from "./json-schema-input.vue?vue&type=template&id=33587635&scoped=true"
import script from "./json-schema-input.vue?vue&type=script&lang=js"
export * from "./json-schema-input.vue?vue&type=script&lang=js"
import style0 from "./json-schema-input.vue?vue&type=style&index=0&id=33587635&prod&lang=scss&scoped=true"
import style1 from "./json-schema-input.vue?vue&type=style&index=1&id=33587635&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33587635",
  null
  
)

export default component.exports